import { CopilotDabEntrypoint } from 'owa-copilot-telemetry/lib/types/scenarios/CopilotDabTypes';
import { getMailContext } from './getMailContext';
import { type ComposeOperation } from 'owa-mail-compose-store/lib/store/schema/ComposeOperation';
import { getComposeViewState } from 'owa-mail-reading-pane-store-conversation/lib/utils/getComposeViewState';

/**
 * Determines where DAB popover is invoked (which is used for the IDEAs all-up dashboards)
 */
export function determineCopilotDabMailEntrypoint(): CopilotDabEntrypoint {
    const { isComposing, isReading } = getMailContext();

    if (isComposing) {
        return getComposeEntrypoint();
    }

    if (isReading) {
        return CopilotDabEntrypoint.ReadingPane;
    }

    return CopilotDabEntrypoint.MessageList;
}

const getComposeEntrypoint = (): CopilotDabEntrypoint => {
    const { operation } = getComposeViewState() || {};
    const isForward = operation === 3;
    const isReply = operation === 1;
    const isReplyAll = operation === 2;

    if (isForward) {
        return CopilotDabEntrypoint.ForwardCompose;
    }

    if (isReply || isReplyAll) {
        return CopilotDabEntrypoint.ReplyReplyAllCompose;
    }

    return CopilotDabEntrypoint.Compose;
};
